import React, { useState, memo } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { CloseMenuIcon } from "@edricphan2022/uikit";
import { IconButton } from "@edricphan2022/uikit";
import { Flex, Box } from "@edricphan2022/uikit";
import { Text } from "@edricphan2022/uikit";
import { Heading } from "@edricphan2022/uikit";
import LogoOrbit from "../LogoOrbit";
import FlexLayout from "../LayoutFlex";

interface MobileProps {
  handleMenuMobile: () => void;
}

const MenuMobile: React.FC<MobileProps> = ({ handleMenuMobile }) => {
  const [isArrMenuMobile] = useState([
    {
      title: `Home`,
      href: "/",
    },
    {
      title: `About`,
      href: "/about",
    },
    {
      title: `Services`,
      href: "/services/web&dev",
    },
    {
      title: `Blockchain`,
      href: "/how-it-works",
    },
    {
      title: `Contact Us`,
      href: "/contact-us",
    },
  ]);

  return (
    <Flex px="16px" py="16px" flexDirection="column" alignItems="flex-start">
      <FlexLayout width="100%">
        <LogoOrbit href="/" />
        <Flex>
          <IconButton
            variant="tertiary"
            startIcon={<CloseMenuIcon width="24px" mr="16.5px" mt="6px" />}
            onClick={handleMenuMobile}
          />
          <Box height="30px" width="1px" background="#333333" />

          <Text ml="16.5px" fontSize="24px" fontFamily="ManropeBold">
            EN
          </Text>
        </Flex>
      </FlexLayout>
      <Flex
        pt="26px"
        pl="20px"
        flexDirection="column"
        alignItems="flex-start"
        onClick={() => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }}
      >
        {isArrMenuMobile.map((_item: any, _index) => (
          <Box pb="36px" display="inline-block">
            <TextNav pb="6px" scale="lg" key={`submenuMobile-${_index}`}>
              <Link to={_item.href}>{_item.title}</Link>
            </TextNav>
          </Box>
        ))}
      </Flex>
    </Flex>
  );
};

const TextNav = styled(Heading)`
  position: relative;
  transition: 0.3s ease;
  font-family: ManropeMedium;

  &::after {
    content: "";
    position: absolute;
    width: 0%;
    height: 2px;
    background-color: #333333;
    left: 0;
    bottom: 0;
    transition: 0.3s ease;
  }

  &:hover {
    ::after {
      width: 100%;
    }
  }
`;

export default memo(MenuMobile);
